import "./App.css";
import React, { Suspense } from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import SideBar from "./components/common/SideBar";
// Lazy — contains loadStripe(); must not run on unrelated routes
const SignUp = React.lazy(() => import("./components/pages/signup/SignUp"));
import { store } from "./actions/store";
import { Provider } from "react-redux";
import SignIn from "./components/pages/signin/signin";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import BaseLayout from "./components/layout/BaseLayOut";
import NotFound from "./components/pages/NotFound";
import Profile from "./components/pages/profile/profile";
import CreditCard from "./components/pages/signup/CreditCard";
import Offers from "./components/pages/offers/Offers";
import Home from "./components/pages/home/Home";
import ForgotPassword from "./components/pages/forgot-password/ForgotPassword";
import AcceptInvitation from "./components/pages/accept-invitation/AcceptInvitation";
import PrivateRoute from "./components/auth/PrivateRoute";
import AdminRoute from "./components/auth/AdminRoute";
import AdminShell from "./components/admin/AdminShell";
import StyleGuide from "./pages/StyleGuide";
import Wallboard from "./components/pages/wallboard/Wallboard";

function RouteErrorPage() {
  const { t } = useTranslation("common");
  const err = useRouteError();
  const isChunk =
    err?.name === "ChunkLoadError" ||
    /Failed to fetch dynamically imported module|Loading chunk/.test(err?.message || "");
  if (isChunk) {
    const key = "route_chunk_reload";
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      window.location.reload();
      return null;
    }
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", fontFamily: "sans-serif", gap: 16, padding: 32 }}>
      <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>{t("errorSomethingWrong")}</h2>
      <p style={{ margin: 0, color: "#666", fontSize: 14, textAlign: "center" }}>
        {isChunk
          ? t("errorNewVersionDeployed")
          : (err?.statusText || err?.message || t("errorUnexpected"))}
      </p>
      <button
        onClick={() => { sessionStorage.removeItem("route_chunk_reload"); window.location.reload(); }}
        style={{ padding: "8px 24px", borderRadius: 8, border: "none", background: "#7A3FE4", color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
        {t("errorRefreshPage")}
      </button>
    </div>
  );
}

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<BaseLayout />} errorElement={<RouteErrorPage />}>
        <Route index element={<Home />} />
        <Route path="signin" element={<SignIn />} />
        <Route path="signup" element={<Suspense fallback={null}><SignUp /></Suspense>} />
        <Route path="offers" element={<Offers />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="accept-invitation" element={<AcceptInvitation />} />

        {/* Protected routes — redirect to /signin if no token */}
        <Route element={<PrivateRoute />}>
          <Route path="sidebar" element={<SideBar />} />
          <Route path="wallboard" element={<Wallboard />} />
          <Route path="style-guide" element={<StyleGuide />} />
        </Route>

        {/* Admin routes — redirect to /signin if no token, /sidebar if not admin */}
        <Route element={<AdminRoute />}>
          <Route path="admin" element={<AdminShell />} />
        </Route>
      </Route>,
    ),
    {
      basename: "/heycallcenter",

      future: {
        v7_startTransition: true,
      },
    },
  );

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
